exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PrimaryImage__imageWrapper--3XRoE{margin:0 -20px 10px}@media (min-width:768px){.PrimaryImage__imageWrapper--3XRoE{margin:0 -35px 10px}}@media (min-width:1025px){.PrimaryImage__imageWrapper--3XRoE{margin:0 -40px 10px}}.PrimaryImage__placeholder--1a1TC{width:100%;height:0;position:relative;padding-top:56.25%;background:#dcdcdc}.PrimaryImage__img--25evc{width:100%;top:0;left:0;position:absolute;line-height:0}", ""]);

// exports
exports.locals = {
	"imageWrapper": "PrimaryImage__imageWrapper--3XRoE",
	"placeholder": "PrimaryImage__placeholder--1a1TC",
	"img": "PrimaryImage__img--25evc"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"modules":true,"localIdentName":"[name]__[local]--[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"sourceMap":false}!./src/components/Library/PrimaryImage/PrimaryImage.css
// module id = ./node_modules/css-loader/index.js?{"sourceMap":false,"minimize":true,"modules":true,"localIdentName":"[name]__[local]--[hash:base64:5]"}!./node_modules/postcss-loader/lib/index.js?{"sourceMap":false}!./src/components/Library/PrimaryImage/PrimaryImage.css
// module chunks = 1